import { ConfigRepositoryParameters } from './configParametersRepository/types';
import { createConfigParametersRepository } from './configParametersRepository';

export {
  trackComponentDisplayed,
  trackDOMComponentDisplayed,
  trackClickEvent,
  trackPageLoaded,
  init,
  setBookingId,
  setSearchId,
  trackClick,
  createDataMeshTrackingClient,
  getPageRenderId, // WARNING: use only in frontend-core, frontend-html5 & frontend-home
} from './html-events';

export { thirdPartyTracking } from './third-party-tracking';

export const initTrackingAgent = (configParams: ConfigRepositoryParameters) => {
  const { init } = createConfigParametersRepository();
  init(configParams);
};
export type {
  ThirdPartyTrackingAgentArgs,
  TrackTMSPageDatalayer,
} from './third-party-tracking';
export type {
  CustomDimensions,
  SetCustomDimensionOrParam,
} from './third-party-tracking/types';
export type {
  CustomDimensionsOrParams,
  CustomParams,
} from './third-party-tracking/google-analytics/ga4Types';
export type { ECommerce4Transaction } from './third-party-tracking/eCommerceTrackingClient/types';
export type { TrackPageOptions } from './third-party-tracking/thirdPartyTrackingAgent/types';
